import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@heroui/react';
import type { CatalogImportMatch } from '@/api/models';
import { MATCH_LABEL_KEYS } from '@/pages/catalogImport/notices';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

type MatchChipProps = {
    match: CatalogImportMatch;
    rowNumber: number;
};

/** What a row does to the catalog: New product, New variant or Restock. */
export const MatchChip: React.FC<MatchChipProps> = ({ match, rowNumber }) => {
    const { t } = useTranslation('pages');

    return (
        <Chip
            data-match={match}
            size="sm"
            variant="secondary"
            {...getNodeTestIdProp(`catalog-import-row-match-${rowNumber}`)}
        >
            {t(MATCH_LABEL_KEYS[match])}
        </Chip>
    );
};
